import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Instagram, ShoppingBag } from "lucide-react";
import { NAV_ITEMS, LINKS } from "../mock/data";
import BrandLogo from "./BrandLogo";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className="fixed top-0 left-0 w-full z-50">
      {/* Announcement bar */}
      <div className="bg-baja-red text-white text-center text-[11px] md:text-xs font-cond uppercase tracking-[0.15em] py-1.5 px-4">
        Website maintained by the Importer of Baja Designs in India &mdash; Motousher
      </div>

      <div
        className={`transition-all duration-300 ${
          scrolled
            ? "bg-[#0a0a0a]/95 backdrop-blur border-b border-white/10 py-3"
            : "bg-gradient-to-b from-black/70 to-transparent py-5"
        }`}
      >
        <div className="max-w-[1400px] mx-auto px-5 md:px-8 flex items-center justify-between">
          <Link to="/" className="group">
            <BrandLogo size={scrolled ? 38 : 44} />
          </Link>

          <nav className="hidden lg:flex items-center gap-8">
            {NAV_ITEMS.map((item) => {
              const active = pathname === item.to;
              return (
                <Link
                  key={item.label}
                  to={item.to}
                  className={`font-cond uppercase tracking-wider text-[15px] relative after:absolute after:left-0 after:-bottom-1 after:h-[2px] after:bg-baja-red after:transition-all after:duration-300 ${
                    active ? "text-white after:w-full" : "text-white/80 hover:text-white after:w-0 hover:after:w-full"
                  }`}
              >
                {item.label}
              </Link>
            );
          })}
        </nav>

        <div className="hidden lg:flex items-center gap-4">
          <a href={LINKS.instagram} target="_blank" rel="noopener noreferrer" className="text-white/80 hover:text-baja-red transition-colors" aria-label="Instagram">
            <Instagram size={22} />
          </a>
          <a
            href={LINKS.shop}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-baja-red hover:bg-[#ff1a44] transition-colors text-white font-cond font-600 uppercase tracking-wider text-sm px-5 py-2.5 flex items-center gap-2"
          >
            <ShoppingBag size={16} /> Shop Now
          </a>
        </div>

        <button className="lg:hidden text-white" onClick={() => setOpen(!open)} aria-label="Menu">
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-[#0a0a0a] border-t border-white/10 mt-3">
          <nav className="flex flex-col px-6 py-4">
            {NAV_ITEMS.map((item) => (
              <Link
                key={item.label}
                to={item.to}
                onClick={() => setOpen(false)}
                className="font-cond uppercase tracking-wider text-lg text-white/80 hover:text-baja-red py-3 border-b border-white/5"
              >
                {item.label}
              </Link>
            ))}
            <div className="flex items-center gap-4 pt-4">
              <a href={LINKS.instagram} target="_blank" rel="noopener noreferrer" className="text-white/80">
                <Instagram size={22} />
              </a>
              <a href={LINKS.shop} target="_blank" rel="noopener noreferrer" className="bg-baja-red text-white font-cond uppercase tracking-wider text-sm px-5 py-2.5 flex items-center gap-2">
                <ShoppingBag size={16} /> Shop Now
              </a>
            </div>
          </nav>
        </div>
      )}
      </div>
    </header>
  );
}
